
  (function () {
    function hideOutOfStockVariants() {
      // Swatch elemanlarını bulma
      const swatchLists = document.querySelectorAll('.card-swatch ul.swatch, .card-swatch .swatch');
      if (!swatchLists.length) return;

      swatchLists.forEach((swatchList) => {
        // Tüm varyant öğelerini seç
        const swatchItems = Array.from(
          swatchList.querySelectorAll('li.item, .group-swatch > div')
        );

        let visibleItemCount = 0;

        swatchItems.forEach(function (item) {
          try {
            // Farklı varyant yapıları için esnek stok kontrolü
            const quantityAttr =
              item.getAttribute('data-quantity') ||
              item.querySelector('[data-quantity]')?.getAttribute('data-quantity');

            const quantity = parseInt(quantityAttr, 10);

            if (isNaN(quantity) || quantity <= 0) {
              item.style.display = 'none'; // Stok dışı olanları gizle
            } else {
              item.style.display = ''; // Stokta olanları göster
              visibleItemCount++;
            }
          } catch (error) {
            console.error('Hata: Bir varyant işlenemedi:', error);
          }
        });

        // "Daha Fazla" butonunu yönet
        const moreButton = swatchList.querySelector('.item-swatch-more');
        if (moreButton) {
          moreButton.style.display = visibleItemCount <= 1 ? 'none' : 'block';
        }
      });
    }

    // Sayfa yüklemesi için kontroller
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hideOutOfStockVariants);
    } else {
      hideOutOfStockVariants();
    }

    // Dinamik içerik için MutationObserver ekle
    const observer = new MutationObserver(function (mutations) {
      let needsUpdate = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          needsUpdate = true;
        }
      });

      if (needsUpdate) {
        hideOutOfStockVariants();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  })();
